import React, {useContext, useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";
import {useLocation} from "react-router-dom";
import {StoreContext} from "../StoreContext/StoreContext";
import './languageControl.scss';

export enum EAppLanguage {
    en = 'en',
    // enai = 'en-ai',
    ru = 'ru',
    // zh = 'zh-ai',
    zoomer = 'zoomer-ai',
}

/**
 * Тема переключателей языка.
 */
export enum ELanguageControlTheme {
    // Для главной страницы.
    main,
    // Для внутренних страниц.
    inner
}

interface ILanguageControlSelectProps {
    theme: ELanguageControlTheme;
}

const LanguageControlSelect: React.FC<ILanguageControlSelectProps> = ({theme}) => {
    const {routesStore} = useContext(StoreContext);
    const {i18n} = useTranslation();
    const location = useLocation();
    const history = useHistory();
	const prevLanguageRef = useRef(i18n.language);

	useEffect(() => {
		i18n.on('languageChanged', (lng) => {
			prevLanguageRef.current = lng;
		});
	}, []);

    const handleChangeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const nextLanguage = event.target.value as EAppLanguage;
        const prevLanguage = prevLanguageRef.current;

        // Id роута. Одинаковый для разных языковых версий одной и той же доски.
        let langId: string | undefined;
        // Роут текущей страницы на другом языке. Либо страница - Раздел еще не переведен.
        // По-умолчанию роут для главной страницы.
        let nextPath = `/${nextLanguage}`;
        // Роут, без языкового префикса.
        const pathWithoutLang = location.pathname.replace(`/${prevLanguage}`, '');

        // Текущая страница не главная, а где-то в канале.
        if (pathWithoutLang) {
            // Название канала - Web/Super/...
            const fileTitle = pathWithoutLang.split('/')[1];
            if (fileTitle) {
                nextPath = `/${nextLanguage}/${fileTitle}/sectionNotTranslated`
            }
        }

        Object.keys(routesStore.routesAndBoardsMap).filter(path => path.startsWith(`/${prevLanguage}/`)).some(path => {
            if (path === location.pathname) {
                langId = routesStore.routesAndBoardsMap[path].routeLangId;
                return true;
            }
        });

        if (langId) {
            Object.keys(routesStore.routesAndBoardsMap).filter(path => path.startsWith(`/${nextLanguage}/`)).some(path => {
                if (routesStore.routesAndBoardsMap[path].routeLangId === langId) {
                    nextPath = path;
                    return true;
                }
            });
        }

        i18n.changeLanguage(nextLanguage);

        history.push({
            pathname: nextPath,
            hash: location.hash,
            search: location.search,
        });
    }

    return (
        <div className={ theme === ELanguageControlTheme.inner ? 'language-control-inner' : 'language-control-main'}>
            <select
                className="language-control-select"
				value={i18n.language}
                onChange={handleChangeLanguage}
            >
				<option value={EAppLanguage.ru}>русский</option>
				<option value={EAppLanguage.en}>english</option>
				{/* <option value={EAppLanguage.enai}>english AI</option> */}
				{/* <option value={EAppLanguage.zh}>中文 AI</option> */}
				<option value={EAppLanguage.zoomer}>зумерский 😊 AI</option>	
            </select>
        </div>
    );
};

export default LanguageControlSelect;
